import { useLocation, useNavigate } from "react-router-dom";
import styles from "./PageNotFound.module.scss";
import routes from "@/routes/routes";
import { captalizeEachWord } from "@/lib/utils";

const PageNotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.code}>404</h1>

        <p className={styles.title}>Page Not Found</p>

        <p className={styles.message}>
          We couldn’t find <b>{location.pathname}</b>
        </p>

        <button
          className={styles.button}
          onClick={() => navigate(routes.privateRoutes.HOME.path)}
        >
          {captalizeEachWord("go back")}
        </button>
      </div>
    </div>
  );
};

export default PageNotFound;
